<template>
    <form @submit.prevent="submit()" enctype="multipart/form-data">
        <!-- Name Field -->
        <div :class="{ 'has-error': errors.name }" class="form-group col-sm-6">
            <label for="name">
                Nombre:
            </label>
            <input class="form-control" id="name" type="text" v-model="data.name">
                <div class="help-block" v-if="errors.name">
                    {{ errors.name }}
                </div>
            </input>
        </div>
        <!-- Id Landing Pages Components Field -->
        <div :class="{ 'has-error': errors.id_footer_category }" class="form-group col-sm-6">
            <label for="id_footer_category">
                Categorias:
            </label>
            <select @change="onChangeComponents()" class="form-control" id="id_footer_category" v-model="data.id_footer_category">
                <option v-bind:value="{ id: component.id }"  v-for="component in categories" v-text="component.category_name" :key="component.id">
                </option>
            </select>
            <div class="help-block" v-if="errors.id_footer_category">
                {{ errors.id_footer_category }}
            </div>
        </div>
        <!-- Active Field -->
        <div class="form-group col-sm-12">
            <label for="active">
                Activo?:
            </label>
            <br/>
            <label>
                <input id="active" type="checkbox" v-model="data.active" value="1">
                </input>
            </label>
        </div>
        <div id="components-1" v-if="showComponent == 1 || showComponent == 2 || showComponent == 3 || showComponent == 4">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <hr/>
            </div>
            <!-- input_title_1 Field -->
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-sm-4">
                <label for="input_title_1">
                    Título:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </input>
            </div>
            <!-- input_title_2 Field -->
            <div :class="{'has-error': errors.input_title_2}" class="form-group col-sm-4">
                <label for="input_title_2">
                    URL:
                </label>
                <input class="form-control" id="input_title_2" type="text" v-model="data.input_title_2">
                    <div class="help-block" v-if="errors.input_title_2">
                        {{ errors.input_title_2 }}
                    </div>
                </input>
            </div>
        </div>
        <div id="components-2" v-if="showComponent == 5">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <hr/>
            </div>
            <!-- input_title_1 Field -->
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-sm-4">
                <label for="input_title_1">
                    Título:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </input>
            </div>
            <!-- input_title_2 Field -->
            <div :class="{'has-error': errors.input_title_2}" class="form-group col-sm-4">
                <label for="input_title_2">
                    URL:
                </label>
                <input class="form-control" id="input_title_2" type="text" v-model="data.input_title_2">
                    <div class="help-block" v-if="errors.input_title_2">
                        {{ errors.input_title_2 }}
                    </div>
                </input>
            </div>
            <div :class="{'has-error': errors.id_icon_category}" class="form-group col-sm-4">
                <label for="id_icon_category">
                    Icono:
                </label>
                <select class="form-control" id="id_icon_category" v-model="data.id_icon_category">
                    <option v-bind:value="{ id: component.icon }"  v-for="component in iconosContactos" v-text="component.name" :key="component.id">
                    </option>
                </select>
                <div class="help-block" v-if="errors.id_footer_category">
                    {{ errors.id_footer_category }}
                </div>
            </div>
         </div>
        <div id="components-3" v-if="showComponent == 6">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <hr/>
            </div>
            <!-- input_title_1 Field -->
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-sm-4">
                <label for="input_title_1">
                    Título:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </input>
            </div>
            <!-- input_title_2 Field -->
            <div :class="{'has-error': errors.input_title_2}" class="form-group col-sm-4">
                <label for="input_title_2">
                    URL:
                </label>
                <input class="form-control" id="input_title_2" type="text" v-model="data.input_title_2">
                    <div class="help-block" v-if="errors.input_title_2">
                        {{ errors.input_title_2 }}
                    </div>
                </input>
            </div>
            <div :class="{'has-error': errors.id_icon_category}" class="form-group col-sm-4">
                <label for="id_icon_category">
                    Icono:
                </label>
                <select class="form-control" id="id_icon_category" v-model="data.id_icon_category">
                    <option v-bind:value="{ id: component.icon}"  v-for="component in iconosRRSS" v-text="component.name" :key="component.id">
                    </option>
                </select>
                <div class="help-block" v-if="errors.id_footer_category">
                    {{ errors.id_footer_category }}
                </div>
            </div>
         </div>
        <!-- Submit Field -->
        <div class="form-group col-sm-12">
            <input class="btn btn-primary" type="submit" value="Guardar">
                <a class="btn btn-default" href="/backend/mantenedor-footer">
                    Cancelar
                </a>
            </input>
        </div>
    </form>
</template>
<script>
    export default {
        data() {
            return {
                errors: {},
                data: [],
                categories: [],
                showComponent: false,
                iconosRRSS: [
                    {
                        id: 1,
                        name: 'Facebook',
                        icon: 'images/icon-facebook.svg'
                    },
                    {
                        id: 2,
                        name: 'X',
                        icon: 'bulma/images/icon-x.svg'
                    },
                    {
                        id: 3,
                        name: 'Instagram',
                        icon: 'images/icon-instagram.svg'
                    },
                    {
                        id: 4,
                        name: 'Youtube',
                        icon: 'images/icon-youtube.svg'
                    },
                    {
                        id: 5,
                        name: 'Spotify',
                        icon: 'images/icon-spotify.svg'
                    },
                    {
                        id: 6,
                        name: 'TikTok',
                        icon: 'images/icon-tiktok.svg'
                    },
                ],
                iconosContactos: [
                    {
                        id: 1,
                        name: 'Mail',
                        icon: 'images/icon-mail.svg'
                    },
                    {
                        id: 2,
                        name: 'Call',
                        icon: 'images/icon-phone.svg'
                    },
                ],
            }
        },
        mounted() {
            this.fetchCatgories();
        },
        methods: {
            onFileChange(e){
                this.data.input_image_1 = e.target.files[0];
            },
            fetchCatgories: function() {
                self = this

                axios({
                    url: 'backend/mantenedor-footer/getcategory',
                    method: 'GET',
                }).then(function(response){
                    self.categories = response.data.categories;
                }).catch(function(error){
                    console.log(error);
                });
            },
            onChangeComponents: function () {
                this.showComponent = this.data.id_footer_category.id;

                // inputs
                this.data.input_title_1 = undefined;
                this.data.input_title_2 = undefined;
                this.data.input_title_3 = undefined;
                // errors
                this.errors.input_title_1 = false;
                this.errors.input_title_2 = false;
                this.errors.input_title_3 = false;
            },
            submit: function(){
                this.errors = {};
                // si campo nombre es vacío
                if(typeof(this.data.name) == undefined || this.data.name == '' || this.data.name == null) {
                    this.errors.name = "El campo Nombre es requerido";
                } else {
                    this.errors.name = false;
                }

                // si campo categoria es vacío
                this.errors.id_footer_category= null;
                if(typeof(this.data.id_footer_category) == undefined || this.data.id_footer_category== '' || this.data.id_footer_category== null) {
                    this.errors.id_footer_category= "El campo categoria de footer es requerido";
                } else {
                    this.errors.id_footer_category= false;
                }

                // para componentes

                var form_component = true;
                for (const error in this.errors) {
                    if (this.errors[error] != false) {
                        form_component = false;
                        break;
                    }
                }

                // Si formulario es válido
                if (!this.errors.name && !this.errors.id_landing_pages_components && form_component) {
                    if (!this.data.active){
                        this.data.active = 0;
                    }

                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    }

                    if ( this.data.id_footer_category.id == 1 || this.data.id_footer_category.id == 2 || this.data.id_footer_category.id == 3 || this.data.id_footer_category.id == 4 ) {
                        let params = new FormData();
                        params.append('component_name', this.data.name);
                        params.append('name', this.data.input_title_1);
                        params.append('url', this.data.input_title_2);
                        params.append('status', this.data.active);
                        params.append('category_id', this.data.id_footer_category.id);

                        axios.post('/backend/mantenedor-footer', params, config)
                        .then((response) => {
                            window.location.replace(response.data.redirect);
                        });

                    } else {
                        let icon_id = this.data.id_icon_category.id ? this.data.id_icon_category.id : 'null'
                        let params = new FormData();
                        params.append('component_name', this.data.name);
                        params.append('name', this.data.input_title_1);
                        params.append('url', this.data.input_title_2);
                        params.append('icon', icon_id);
                        params.append('status', this.data.active);
                        params.append('category_id', this.data.id_footer_category.id);

                        axios.post('/backend/mantenedor-footer', params, config)
                        .then((response) => {
                            window.location.replace(response.data.redirect);
                        });
                    }
                }
            }
        }
    }
</script>
